import {
  APPOINTMENT_ERROR_I18N,
  IMPERSONATION_ERROR_I18N,
  MCP_ACCESS_ERROR_I18N,
  PROSPECT_ERROR_I18N,
} from '@niko-crm/core/constants';

/**
 * Maps known backend error message substrings to transloco translation keys.
 * Used by extractError() to surface localised messages instead of raw English strings.
 * Keys must match those defined in assets/i18n/es.json (and en.json).
 */
export const BACKEND_ERROR_MAP: Record<string, string> = {
  // Legacy substring for phone-uniqueness — kept until PROSPECT_PHONE_ALREADY_EXISTS
  // (below, via PROSPECT_ERROR_I18N) is deployed on both sides.
  'already exists in this tenant':   'errors.phoneAlreadyExists',
  'User account is disabled':        'errors.userDisabled',
  'Business suspended':              'errors.businessSuspended',
  'Invalid or expired token':        'errors.tokenExpired',
  'Unauthorized':                    'errors.tokenExpired',
  'Not Found':                       'errors.notFound',
  'Forbidden resource':              'errors.forbidden',
  'Missing permission':              'errors.forbidden',
  'RESOURCE_IN_USE':                 'errors.resourceInUse',
  'RESOURCE_ALREADY_EXISTS':         'errors.resourceAlreadyExists',
  'VALUE_NOT_ALLOWED':               'errors.valueNotAllowed',
  'Config value already exists':     'errors.configAlreadyExists',
  'PUBLIC_BASE_URL is not configured': 'errors.coexPublicBaseUrlMissing',
  'Tenant configuration META_API_VERSION is missing': 'errors.metaApiVersionMissing',
  'Unsupported get request':         'errors.metaObjectUnavailable',
  'is missing or empty. Configure it under': 'errors.coexTenantConfigMissing',
  'Run the seed-system-configs script': 'errors.coexSeedMissing',
  'SYSTEM_STAGE_DEFAULT_IMMUTABLE': 'errors.systemStageDefaultImmutable',
  'SYSTEM_STAGE_ENABLED_IMMUTABLE': 'errors.systemStageEnabledImmutable',
  'must be a valid JSON object':     'errors.invalidJsonObject',
  'must be a valid JSON value':      'errors.invalidJson',
  'must not be in the past':         'errors.prospectFollowUpPastDate',
  'ORIGIN_GROUP_MANUAL_ALREADY_EXISTS': 'errors.originGroupManualAlreadyExists',
  // Cognito. The explicit backend code comes first: `UsersService.setActive`
  // raises it when a `users` row points at a Cognito account that no longer
  // exists (data integrity, not a transient failure). The two generic entries
  // below catch the raw AWS text from any other Cognito call site so it does
  // not fall through to "unknown".
  'COGNITO_ACCOUNT_NOT_FOUND':       'errors.cognitoAccountNotFound',
  'User does not exist':             'errors.cognitoAccountNotFound',
  'Could not reactivate user':       'errors.cognitoActivationFailed',
  'Could not deactivate user':       'errors.cognitoActivationFailed',
  ...PROSPECT_ERROR_I18N,
  ...IMPERSONATION_ERROR_I18N,
  ...MCP_ACCESS_ERROR_I18N,
  ...APPOINTMENT_ERROR_I18N,
};
